import React from 'react';

function Experience() {
    return (

        <div className="experience">
            <h3>Formations</h3>
            <div className="exp-1">
                <h4>
                    Développeur d'application PHP/Symfony
                </h4>
                <h5>02/2019-02/2022 OpenClassrooms Paris 19</h5>
                <p>
                    - Analyser un cahier des charges et choisir une solution technique adaptée parmi
                    les solutions existantes<br/>
                    - Concevoir l’architecture technique d’une application à l’aide de diagrammes
                    UML<br/>
                    - Créer des projets web dynamiques grâce PHPCommuniquer avec une base de
                    données pour stocker et requêter des informations<br/>
                    - Développer de manière professionnelle grâce au framework Symfony
                    Mettre en oeuvre des tests unitaires et fonctionnels ainsi qu’utiliser les outils les
                    plus connus d’intégration continue<br/>
                    - Produire une documentation technique et fonctionnelle de l’applicationPrendre
                    en compte les problématiques de performance d’une application PHP
                </p>
            </div>
            <div className="exp-2">
                <h4>
                    Chef de projet multimédia - Développement
                </h4>
                <h5>08/2017 - 01/2019 OpenClassrooms Paris 19</h5>
                <p >
                    - Analyser les besoins et objectifs d’un client lors d’un rendez-vous ou appel à
                    projets<br/>
                    - Rédiger une proposition sous la forme d’un cahier des charges<br/>
                    - Soutenir votre proposition lors d’une présentation au client<br/>
                    - Piloter un projet dans le respect du planning et du budget<br/>
                    - Élaborer un rétro-planning et un échéancier<br/>
                    - Rédiger un cahier des charges technique et fonctionnel<br/>
                    - Animer des réunions de suivi et de cadrage<br/>
                    - Travailler en équipe avec une méthodologie de gestion de projet<br/>
                    - Communiquer avec le client pour effectuer une proposition commerciale<br/>
                    - Créer des sites web interactifs en HTML5, CSS, JavaScript, Bootstrap<br/>
                    - Concevoir des applications professionnelles à l’aide de PHP, du framework<br/>
                    - Symfony et du gestionnaire de versions Git<br/>
                </p>
            </div>
        </div>
    );
}

export default Experience;
